import React from 'react';
import tickIcon from '../../icons/tickWhite.svg';

export default (props) => (
  <a
    tabIndex={0}
    className={`questionOption ${props.aggregatedQuestions.includes(props.option.weightingName) ? "selected" : null }`}
    onClick={ (e) => {
      e.preventDefault();
      props.onAnswerClick(props.option.weightingName);
      props.trackEvent('Fragrance_Experience', `Answered Question: ${props.option.weightingName}`, `Answered Question ${props.questionNumber}`,  {"answer": props.option.weightingName})
    }}
    onKeyDown={ (e) => {
      let code = e.charCode || e.keyCode;
      if((code === 32)|| (code === 13)) {
        e.preventDefault();
        props.onAnswerClick(props.option.weightingName);
        props.trackEvent('Fragrance_Experience', `Answered Question: ${props.option.weightingName}`, `Answered Question ${props.questionNumber}`,  {"answer": props.option.weightingName})
      }
    }}
    role="button"
    href={props.nextQuestion}
    aria-labelledby={`Option-${props.index}`}
  >
    { props.aggregatedQuestions.includes(props.option.weightingName) ?
      <div className="selectedCheck">
        <img className="tickIcon" src={tickIcon} alt="selected" />
      </div>
    : null }
    <div className="imgWrapper">
      <img src={props.option.img} alt={props.option.text} />
    </div>
    <div className="optionText">
      <p className="serif fwb em" id={`Option-${props.index}`}>{props.option.text}</p>
    </div>
  </a>
)


// WEBPACK FOOTER //
// ./src/components/QuestionOption/QuestionOption.js